
  import { css } from 'lit';
  export const styles = css`:host{--handle-color: var(--ig-splitter-handle-color, var(--ig-gray-800));--expander-color: var(--ig-splitter-expander-color, var(--ig-gray-800));--ig-theme-variant: dark}`;
  